import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import useMediaQuery from '../../Layout/Hooks/useMediaQuery';
import { defaultUserTheme, mobileFontsTheme } from './themeObjs';
import * as filler from './fillDefaults';
import useThemeUtils from './useThemeUtils';
import ThemeEditor from './ThemeEditor';
const CronoTheme = ({ children, theme, showThemeEditor }) => {
    var _a;
    const { currentMedia, mediaDownFrom, mediaUpFrom } = useMediaQuery();
    const [userTheme, setUserTheme] = useState(Object.assign(Object.assign({}, defaultUserTheme), theme));
    useEffect(() => {
        if (mediaDownFrom('md')) {
            setUserTheme(Object.assign(Object.assign({}, userTheme), { fonts: mobileFontsTheme }));
        }
        else if (mediaUpFrom('md')) {
            setUserTheme(Object.assign(Object.assign({}, userTheme), { fonts: Object.assign(Object.assign({}, defaultUserTheme), userTheme.fonts) }));
        }
    }, [currentMedia]);
    useEffect(() => {
        if (theme) {
            setUserTheme(Object.assign(Object.assign({}, defaultUserTheme), theme));
        }
    }, [theme]);
    const { lightenDarkenColor, getColor, getColorDark, getColorLight, getSize, getControlStyle, getOptionStyle, getPlaceholderStyle, getSingleValue, getMultiValue, getMultiValueLabel, getMultiValueRemove, getMenuPortal, borderColor, borderColorDouble, customBorders } = useThemeUtils({ colors: filler.colorsWithDefaults(userTheme), fonts: filler.fontsWithDefaults(userTheme) });
    const utils = {
        lightenDarkenColor,
        getColor,
        getColorLight,
        getColorDark,
        getSize,
        getControlStyle,
        getOptionStyle,
        getPlaceholderStyle,
        getSingleValue,
        getMultiValue,
        getMultiValueLabel,
        getMultiValueRemove,
        getMenuPortal,
        borderColor,
        borderColorDouble,
        customBorders
    };
    const finalTheme = {
        colors: filler.colorsWithDefaults(userTheme),
        fonts: filler.fontsWithDefaults(userTheme),
        borders: filler.bordersWithDefaults(userTheme),
        boxes: filler.boxesWithDefaults(userTheme),
        paddingsMargins: filler.paddingsMarginsWithDefaults(userTheme),
        spacings: filler.spacingsWithDefaults(userTheme),
        logo: (_a = userTheme.logo) !== null && _a !== void 0 ? _a : defaultUserTheme.logo,
        utils
    };
    return (_jsxs(ThemeProvider, Object.assign({ theme: finalTheme }, { children: [showThemeEditor &&
                _jsx(ThemeEditor, { setThemeEditor: setUserTheme, themeEditor: userTheme }), children] })));
};
export default CronoTheme;
